<template>
  <EmpDownloadStatusToast
    :visible="display.visible"
    :variant="display.variant"
    :title="display.title"
    :subtitle="display.subtitle"
    :context-label="display.contextLabel"
    :close-label="$t('lbl_EMPBE_OpLog_ExportToastClose')"
    @close="onClose"
  />
</template>

<script>
import {
  oplogExportHud,
  oplogExportHudDismissToast,
} from "@/_helpers/oplogExportHud.store";
import { empDownloadHud, empDownloadHudClose } from "@/_helpers/empDownloadHud.store";

/**
 * 全局下載進度 Toast 宿主：聚合「操作日誌導出」與通用 $empDownloadHud。
 * 掛在 App 根節點一次即可；關閉供應商彈層後仍可顯示後台導出進度。
 */
export default {
  name: "EmpDownloadHudHost",
  computed: {
    display() {
      const op = oplogExportHud;
      if (op.toastVisible) {
        /** 操作日誌 / 銷售線索等共用 HUD；progressTitle 非空時覆蓋默認文案 */
        const title = op.progressTitle || this.$t("lbl_EMPBE_OpLog_ExportProgressTitle");
        const subtitle = op.progressSubtitle || this.$t("lbl_EMPBE_OpLog_ExportProgressSubtitle");
        return {
          visible: true,
          variant: "progress",
          title,
          subtitle,
          contextLabel: op.exportContextLabel || "",
        };
      }
      const g = empDownloadHud;
      if (g.visible && g.mode === "manual") {
        return {
          visible: true,
          variant: g.variant === "error" ? "error" : "progress",
          title: g.title,
          subtitle: g.subtitle,
          contextLabel: g.contextLabel || "",
        };
      }
      return {
        visible: false,
        variant: "progress",
        title: "",
        subtitle: "",
        contextLabel: "",
      };
    },
  },
  methods: {
    onClose() {
      if (oplogExportHud.toastVisible) {
        oplogExportHudDismissToast();
      } else {
        empDownloadHudClose();
      }
    },
  },
};
</script>
